import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { dashboardCatalogFor, type DashboardCatalog } from '@crm/shared/i18n';

interface I18n {
  /** The `Intl` locale for numbers and dates. */
  readonly locale: string;
  readonly t: DashboardCatalog;
}

const I18nContext = createContext<I18n>({
  locale: 'uz-Latn',
  t: dashboardCatalogFor('uz-Latn'),
});

/** Provides the catalog for a locale (the user's preferred locale; Uzbek Latin by default). */
export function I18nProvider({ locale, children }: { locale: string; children: ReactNode }) {
  const value = useMemo<I18n>(
    () => ({ locale: locale === 'en' ? 'en' : 'uz-Latn', t: dashboardCatalogFor(locale) }),
    [locale],
  );
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

/** All UI text comes from here; components never hold strings of their own. */
export const useT = (): DashboardCatalog => useContext(I18nContext).t;
export const useLocale = (): string => useContext(I18nContext).locale;
